import request from '@/utils/request'
import requested from '@/utils/requested'

// var base_url2 = CONFIG.baseUrl2
// if(base_url.indexOf('https:') == 0 && document.location.protocol != 'https:' && location.href.indexOf('//127.0.0.1') == -1 && location.href.indexOf('//localhost') == -1 && location.href.indexOf('//192.') == -1 && location.href.indexOf('//10.') == -1)
// {
//   base_url =  location.replace('https://'+location.href.substring(7));
// }
export const serve = data => {
  return request({
    method: 'POST',
    url:`open/enterprise/wx_services.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const https = data => {
  return request({
    method: 'POST',
    // url:`open/enterprise/services.php`, //${base_url}open/enterprise/services.php`,
    url:`open/enterprise_test/services.php`,
    data
  })
}

export const emails = data => {
  return request({
    method: 'POST',
    url:`open/email/email.php`, //${base_url}open/enterprise/services.php`,
    data
  })
}

export const hscp = data => {
  return requested({
    method: 'POST',
    url:`open/sc_services.php`, //http://www.fondcard.net/open/sc_services.php`,
    data
  })
}

export const serve2 = data => {
  return request({
    method: 'POST',
    url:`open/enterprise_test/services.php`, //https://web.fondcard.net/open/test/wx_services.php`,
    data
  })
}


